module.exports = __webpack_public_path__ + "media/reskin-images/icon--play-v2-sm-f3b63cde.svg";